<template>
  <div class="store-item">
    <div class="store-flex">
      <div class="left">
        <PartItem
          :styles="{
            width: '182px',
            height: '18px',
            'border-radius': '4px',
            'margin-bottom': '8px',
          }"
        ></PartItem>
        <PartItem
          :styles="{ width: '182px', height: '14px', 'border-radius': '4px' }"
        ></PartItem>
      </div>
      <div class="right">
        <PartItem
          :styles="{ width: '92px', height: '92px', 'border-radius': '4px' }"
        ></PartItem>
      </div>
    </div>
  </div>
</template>
<script>
import PartItem from './partItem.vue';

export default {
  components: {
    PartItem,
  },
};
</script>
<style lang="scss" scoped>
.store-item {
  padding: 10px;
  width: 306px;
  height: 156px;
  background: #ffffff;
  border-radius: 8px;
  margin-bottom: 20px;
  .store-flex {
    display: flex;
  }
  .left {
    margin-right: 12px;
  }
}
</style>
